<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left m-0">
            Sincronizando Imagens dos Usuários
          </h4>

          <div
            class="tab-content"
            id="pills-tabContent"
            style="min-height: 100px;"
          >
            <div class="tab-pane fade show active">
              <div class="row justify-content-center mt-2">
                <div class="row w-100 mt-2">
                  <div class="col-sm-12">
                    <p class="text-muted text-start">
                      <strong>Sincronização Completa:</strong> Irá sincronizar
                      as imagens de todos os funcionários associados a este
                      relógio.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row d-flex justify-content-start mt-3">
            <div class="col-sm-3">
              <base-button
                block
                type="success"
                @click="sincRepRelogio"
                :disabled="validateForm()"
              >
                Rep 671 para Relógio
              </base-button>
            </div>
            <div class="col-sm-3">
              <base-button
                block
                type="success"
                @click="sincUsuarios"
                :disabled="validateForm()"
              >
                Relógio para Rep 671
              </base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="vld-parent">
      <loading-overlay
        :percentage="loadingPercentage"
        :isVisible="isLoadingIndicator"
      />
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";
import swal from "sweetalert2";
import LoadingOverlay from "../../components/Loaging/LoadingOverlay.vue";

const https = require("https");

const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
});

export default {
  components: {
    Card,
    LoadingOverlay,
  },

  data() {
    return {
      isLoadingIndicator: false,
      loadingPercentage: 0,
      dadosRelogio: {
        ip: "",
        session: "",
        id_empregador: "",
        tipoAfd: "",
        modelo: "",
        porta: "",
        usuario: "",
        senha: "",
      },
      listaCpf: [],
      imagensUsers: [],
    };
  },

  mounted() {
    this.carregaDadosRelogio(this.$route.params.id);
  },

  methods: {
    validateForm() {
      return !this.dadosRelogio.session;
    },

    listarEmpregados() {
      this.loadingPercentage = 1;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      return this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          const filteredEmpregados = response.data.data.dados.filter(
            (fun) => fun.id_empregador === this.dadosRelogio.id_empregador,
          );

          this.listaCpf = filteredEmpregados
            .map((fun) => {
              const cleanCpf = String(fun.cpf || "").replace(/\D/g, "");
              return Number(cleanCpf);
            })
            .filter((cpf) => !isNaN(cpf) && cpf > 0);
        })
        .catch((err) => {
          console.error("Erro ao listar empregados:", err);
          this.listaCpf = [];
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao obter lista de funcionários",
            "error",
          );
          throw err;
        });
    },

    sincRepRelogio() {
      this.isLoadingIndicator = true;
      this.listarEmpregados()
        .then(() => {
          return this.buscarImagensApiFacial();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    buscarImagensApiFacial() {
      const total = this.listaCpf.length;
      if (total === 0) {
        this.showSwal(
          "auto-close",
          "Aviso",
          "Nenhum usuário encontrado para sincronizar.",
          "warning",
        );
        return Promise.resolve();
      }

      const imagesToUpload = [];
      let sequence = Promise.resolve();

      for (let i = 0; i < total; i++) {
        const cpf = this.listaCpf[i];
        sequence = sequence.then(() => {
          const formData = new FormData();
          const formattedCpf = String(cpf).padStart(11, "0");
          formData.append("nrCpf", formattedCpf);
          return this.axios
            .post(
              `${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/getFotoRecente`,
              formData,
            )
            .then((response) => {
              if (
                response.data &&
                response.data.ImagemRecente &&
                response.data.ImagemRecente[0]
              ) {
                imagesToUpload.push({
                  image: response.data.ImagemRecente[0],
                  user_id: cpf,
                  timestamp: Math.floor(Date.now() / 1000),
                });
              }
              this.loadingPercentage = Math.round((i / total) * 50);
            })
            .catch((err) => {
              console.error(`Erro ao carregar foto do CPF ${cpf}:`, err);
            });
        });
      }

      return sequence.then(() => {
        if (imagesToUpload.length === 0) {
          this.showSwal(
            "auto-close",
            "Aviso",
            "Nenhuma imagem encontrada na API facial para os CPFs selecionados.",
            "warning",
          );
          return;
        }
        return this.uploadImagensRelogio(imagesToUpload);
      });
    },

    uploadImagensRelogio(images) {
      let index = 0;
      const total = images.length;

      const nextBatch = () => {
        if (index >= total) {
          return Promise.resolve();
        }
        const batch = images.slice(index, index + 2);
        const formData = {
          match: false,
          user_images: batch,
        };
        index += 2;

        return this.axios
          .post(
            `https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/user_set_image_list.fcgi?session=${this.dadosRelogio.session}`,
            formData,
            { httpsAgent },
          )
          .then(() => {
            this.loadingPercentage =
              50 + Math.min(Math.round((index / total) * 50), 50);
            return nextBatch();
          })
          .catch((err) => {
            console.error(
              "Erro ao enviar batch de imagens para o relógio:",
              err,
            );
            this.loadingPercentage =
              50 + Math.min(Math.round((index / total) * 50), 50);
            return nextBatch();
          });
      };

      return nextBatch().then(() => {
        this.showSwal(
          "auto-close",
          "Sucesso",
          "Imagens sincronizadas com sucesso no relógio",
          "success",
        );
      });
    },

    sincUsuarios() {
      this.isLoadingIndicator = true;
      this.listarEmpregados()
        .then(() => {
          return this.buscarImagensIdFace();
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    buscarImagensIdFace() {
      if (this.listaCpf.length === 0) {
        this.showSwal(
          "auto-close",
          "Aviso",
          "Nenhum usuário encontrado para sincronizar.",
          "warning",
        );
        return Promise.resolve();
      }

      const form = {
        user_ids: this.listaCpf,
      };

      return this.axios
        .post(
          `https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/user_get_image_list.fcgi?session=${this.dadosRelogio.session}`,
          form,
          { httpsAgent },
        )
        .then((res) => {
          if (res.data && res.data.user_images) {
            this.imagensUsers = res.data.user_images
              .filter((item) =>
                Object.prototype.hasOwnProperty.call(item, "image"),
              )
              .map((us) => {
                return {
                  cpf: us.id,
                  imagem: us.image,
                };
              });
          } else {
            this.imagensUsers = [];
          }
          return this.cadastraImagensRep();
        })
        .catch((err) => {
          console.error("Erro ao obter imagens do relógio:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar com o relógio!",
            "error",
          );
        });
    },

    cadastraImagensRep() {
      const total = this.imagensUsers.length;
      if (total === 0) {
        this.showSwal(
          "auto-close",
          "Aviso",
          "Nenhuma imagem retornada do relógio.",
          "warning",
        );
        return Promise.resolve();
      }

      let sequence = Promise.resolve();
      for (let i = 0; i < total; i++) {
        const user = this.imagensUsers[i];
        sequence = sequence.then(() => {
          return this.uploadImagem(user.cpf, user.imagem).then(() => {
            this.loadingPercentage = Math.round(((i + 1) / total) * 100);
          });
        });
      }

      return sequence
        .then(() => {
          this.showSwal(
            "auto-close",
            "Sucesso",
            "Imagens sincronizadas com sucesso",
            "success",
          );
        })
        .catch((err) => {
          console.error(err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar imagens",
            "error",
          );
        });
    },

    uploadImagem(cpf, imagem) {
      if (!cpf || !imagem) {
        return Promise.resolve();
      }
      const formData = new FormData();
      formData.append("image", imagem);
      const formattedCpf = String(cpf).padStart(11, "0");
      formData.append("nrCpf", formattedCpf);

      return this.axios
        .post(
          `${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/classify`,
          formData,
        )
        .catch((err) => {
          console.error(`Erro ao fazer upload da imagem do CPF ${cpf}:`, err);
        });
    },

    carregaDadosRelogio(id) {
      this.isLoadingIndicator = true;
      const form = {
        setDB: this.$cookies.get("db"),
        id: id,
      };
      this.axios
        .post("/api/relogio/listarRelogios/id", form)
        .then((response) => {
          if (
            response.data &&
            response.data.data &&
            response.data.data.dados &&
            response.data.data.dados[0]
          ) {
            const {
              ip,
              sessao,
              id_empregador,
              tipoAfd,
              modelo,
              porta,
              senha,
              usuario,
            } = response.data.data.dados[0];
            this.dadosRelogio.ip = ip;
            this.dadosRelogio.session = sessao;
            this.dadosRelogio.id_empregador = id_empregador;
            this.dadosRelogio.tipoAfd = tipoAfd;
            this.dadosRelogio.modelo = modelo;
            this.dadosRelogio.porta = porta;
            this.dadosRelogio.senha = senha;
            this.dadosRelogio.usuario = usuario;
          }
        })
        .catch((err) => {
          console.error("Erro ao carregar dados do relógio:", err);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar dados do relógio",
            "error",
          );
        })
        .finally(() => {
          this.isLoadingIndicator = false;
          this.loadingPercentage = 0;
        });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>

<style scoped></style>
